import React, { useEffect, useMemo, useState } from "react";
import ProfileEditing from "../children/ProfileEditing";
import { capitalizeFirstLetter, notifyError } from "../../../../helpers/helpers";
import Location from "../../location/Location";
import { useDispatch, useSelector } from "react-redux";
import { updateOrganizationDetails } from "../../../../redux/action/organization";
import { ClipLoader } from "react-spinners";

function ProfileSection({ organizationData }) {
  const dispatch = useDispatch()
  const [editButton, setEditButton] = useState(false);
  const [editProfileData, setEditProfileData] = useState([]);
  const { uploadLoading } = useSelector((state) => state.organizationDetails);
  const [values, setValues] = useState({
    location: {
      longitude: "",
      latitude: "",
      address: "",
      city: "",
      state: "",
      country: ""
    },
  });

  const InitialProfileData = useMemo(
    () => [
      {
        profileName: capitalizeFirstLetter(organizationData?.owner?.phoneNumber || "N/A"),
        iconsName: "phone",
        type: "phone",
        name: "Phone Number"
      },
      {
        profileName: organizationData?.owner?.email || "N/A",
        iconsName: "email",
        type: "email",
        name: "Email"
      },
      {
        profileName: (
          organizationData?.organizationName || "N/A"
        ),
        iconsName: "corporate_fare",
        type: "text",
        name: "Organization Name"
      },
    ],
    [organizationData]
  );

  const handleUpdateProfile = () => {
    const data = {
      organizationName: editProfileData[2]?.profileName,
      location: {
        address: values?.location?.address,
        city: values?.location?.city,
        state: values?.location?.state,
        country: values?.location?.country,
        longitude: values?.location?.longitude,
        latitude: values?.location?.latitude,
      },
    }

    if (data?.organizationName === '' || data?.organizationName === null || data?.location?.address === "" || data?.location?.address === null) {
      return notifyError("Please fill all the fields")
    }
    if (uploadLoading) return;
    dispatch(updateOrganizationDetails(data, setEditButton))
  }

  useEffect(() => {
    setEditProfileData([...InitialProfileData]);
    setValues((prevValues) => ({
      ...prevValues,
      location: {
        ...prevValues.location,
        ...organizationData?.location,
      },
    }));
  }, [InitialProfileData, organizationData]);



  return (
    <div className={`cover white p-2 mt-1`}>
      {!editButton && (
        <div className="flex space-between mb-1">
          <h5 className="">Your Account Information</h5>
          <button
            className={`button-style pointer`}
            style={{
              padding: "10px 25px",
              border: "1px solid purple",
            }}
            onClick={() => setEditButton((prev) => !prev)}
            type="submit"
          >
            Edit
          </button>
        </div>
      )}
      <div className={`mb-1 valign-wrapper gap-1 `}>
        <span
          className="material-icons cercle-purple-text"
          style={{ fontSize: "25px" }}
        >
          location_on
        </span>
        {editButton ? (
          <div className="full-width mr-2"><Location values={values} setValues={setValues} /></div>
        ) : (
          <p className="title">Location: {organizationData?.location?.address}</p>
        )}
      </div>
      {editProfileData?.map((items, index) => (
        <ProfileEditing
          profileName={items.profileName}
          iconsName={items.iconsName}
          name={items.name}
          editButton={editButton}
          setEditProfileData={setEditProfileData}
          key={index}
          type={items?.type}
          index={index}
        />
      ))}

      <div className="flex justify-center mt-2">
        {editButton && (
          <div className="flex gap-1">
            <button
              className="p-1 border-1px cercle-purple white-text border-radius-12 title pointer"
              onClick={() => handleUpdateProfile()}
            >
              {uploadLoading ? <ClipLoader color="#fff" size={20} /> : "Save Changes"}
            </button>
            <button
              className="p-1 border-1px cercle-purple white-text border-radius-12 title pointer"
              onClick={() => setEditButton(false)}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileSection;
